import * as React from 'react';
import type { PersistedError } from 'state/persisted/types';
import { Link, AnchorContainer } from './styled';
import { getRelativeBasePath } from '@atlassian/help-center-common-util/history';
import { LOGIN_ROUTE } from 'routes/common/constants';

interface ErrorLinkProps extends Partial<PersistedError> {
    callToActionUrl: string;
    children?: React.ReactNode;
}

export const ErrorLink: React.FC<ErrorLinkProps> = ({ callToActionUrl, children }) => {
    if (callToActionUrl.includes(LOGIN_ROUTE)) {
        return (
            <AnchorContainer actionSubjectId="redirectToLogin" href={getRelativeBasePath() + callToActionUrl}>
                {children}
            </AnchorContainer>
        );
    }

    return (
        <Link actionSubjectId="callToAction" to={callToActionUrl}>
            {children}
        </Link>
    );
};

ErrorLink.displayName = 'ErrorLink';
